import {
	Card,
	CardContent,
	Grid,
	Typography,
	CardActionArea,
} from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
import {
	modellingPortalIntro, modellingPortalSubIntro,
	nationalPipelineIntro,
	pipelineModellingIntro,
	statePipelineIntro,
	nationalMapIntro
} from "../assets/texts/pageTextContent";

const style: any = {
	card: {
		width: "calc(70% + 50px)",
		height: "calc(100% + 50px)",
		"&:hover": {
			backgroundColor: "#005670",
			color:"white"
		},
		p:1
	},
	cardAction: {
		width: "calc(100%)",
		height: "calc(100%)",
		p:1
	}
}

export default function MarketCapPortal () {

	return<>
		<Grid container direction="row" alignItems="flex-start" spacing={1} sx={{ p: "2%"}}>
			<Grid item xs={7}>
				<Typography variant={"h2"} sx={{ p: 2}}>
					{modellingPortalIntro}
					<br/>
					<br/>
				</Typography>
			</Grid>
			<Grid
				item
				xs={12}
				container
				justifyContent="flex-start"
				spacing={2}
			>
				<Grid item xs={3}>
					<Card sx={style.card}
						variant="outlined">
						<CardActionArea sx={style.cardAction} component={Link} to={"/national-modelling"} >
							<CardContent>
								<Typography
									variant={"h2"}
									component="div"
									sx={{
										pt: 4,
										pb: 2,
										textDecoration: "underline"
									}}
								>
                                    National Pipeline
								</Typography>
								<Typography variant={"h4"} component="div">
									{nationalPipelineIntro}
								</Typography>
							</CardContent>
						</CardActionArea>
					</Card>
				</Grid>
				<Grid container item xs={3} direction="row" alignItems="center">
					<Card sx={style.card} variant="outlined" >
						<CardActionArea sx={style.cardAction} component={Link} to={"/state-modelling"} >
							<CardContent>
								<Typography
									variant={"h2"}
									component="div"
									sx={{
										pt: 4,
										pb: 2,
										textDecoration: "underline"
									}}
								>
                                    State Pipeline
								</Typography>
								<Typography variant={"h4"} component="div">
									{statePipelineIntro}
								</Typography>
							</CardContent>
						</CardActionArea>
					</Card>
				</Grid>
				<Grid container item xs={3} direction="row" alignItems="center">
					<Card sx={style.card} variant="outlined">
						<CardActionArea sx={style.cardAction} component={Link} to={"/scenario-modelling"}>
							<CardContent>
								<Typography
									variant={"h2"}
									component="div"
									sx={{
										pt: 4,
										pb: 2,
										textDecoration: "underline"
									}}
								>
                                    Pipeline Simulator
								</Typography>
								<Typography variant={"h4"} component="div">
									{pipelineModellingIntro}
								</Typography>
							</CardContent>
						</CardActionArea>
					</Card>
				</Grid>
				<Grid container item xs={3} direction="row" alignItems="center">
					<Card sx={style.card} variant="outlined">
						<CardActionArea sx={style.cardAction} component={Link} to={"/national-map"}>
							<CardContent>
								<Typography
									variant={"h2"}
									component="div"
									sx={{
										pt: 4,
										pb: 2,
										textDecoration: "underline"
									}}
								>
                                    Market Capacity Map
								</Typography>
								<Typography variant={"h4"} component="div">
									{nationalMapIntro}
								</Typography>
							</CardContent>
						</CardActionArea>
					</Card>
				</Grid>
			</Grid>
		</Grid>
	</>;
}
